import { point } from "@turf/helpers";
import { Coordinates } from "../../graphql/generated";

const coordinatesToTurfPoint = (coordinates: Coordinates) => {
  return point([coordinates.longitude, coordinates.latitude]);
};

export default coordinatesToTurfPoint;
